import styled from 'styled-components';

/**
 * Same shape as the calendar view's badge (rounded-full, 6px side padding, 12px text, green on light
 * green), drawn from this app's theme palette rather than the raw hex the Tailwind version uses.
 */
export const StyledIntegrationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  /* Keeps its own 18px height inside flex rows that would otherwise stretch it (the tile's label row). */
  align-self: center;
  width: fit-content;
  padding: 0 6px;
  border-radius: 9999px;
  font: 400 12px/18px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.palette.systemGreen};
  background-color: ${({ theme }) => theme.colors.palette.systemGreenLight};
  white-space: nowrap;
`;
